import { render, staticRenderFns } from "./association_member.vue?vue&type=template&id=63902414"
import script from "./association_member.vue?vue&type=script&lang=js"
export * from "./association_member.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports